/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
} from "react-table";
import "./filtering.css";
import CreatableSelect from "react-select/creatable";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../../services/AxiosInstance";
import CustomOption from "./CustomOption";

export const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <input
        className="form-control input-search"
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};

export const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <div>
      Search :{" "}
      <input
        type="search"
        className="ml-2 input-search form-control"
        value={filter || ""}
        onChange={(e) => setFilter(e.target.value)}
        style={{ width: "20%" }}
      />
    </div>
  );
};

export const Links = () => {
  const keys = ["id", "name", "link", "type.name"];
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [fieldvalue, setFieldValue] = useState();
  const [types, setTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const onShow = () => setShow(true);
  const onHide = () => setShow(false);
  const COLUMNS = [
    ...keys.map((key) => ({
      Header: key.replace(/[_\\.]/g, " "),
      Footer: key.replace(/_/g, " "),
      accessor: key,
      Filter: ColumnFilter,
    })),
    {
      Header: "Action",
      Footer: "Action",
      Cell: ({ row }) => {
        const DeleteLink = (id) => {
          setLoader(true);
          try {
            axiosInstance
              .delete(`admin/del/description/data/${id}`)
              .then((response) => {
                if (response.data.status === true) {
                  getLinks();
                  toast.success(response.data.message);
                  setLoader(false);
                } else {
                  toast.error("SomeThing went Wrong");
                  setLoader(false);
                }
              })
              .catch((errors) => {
                toast.error("SomeThing went Wrong");
                setLoader(false);
              });
          } catch (error) {
            toast.error(error);
          }
        };
        return (
          <>
            <div className="d-flex gap-2">
              <button
                onClick={() => {
                  DeleteLink(row.original.id);
                }}
                title="Edit"
                className={`btn btn-outline-danger btn-sm rounded`}
              >
                <i className="fa fa-trash" />
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const [columns] = useState(COLUMNS);
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    setGlobalFilter,
  } = tableInstance;
  const { globalFilter } = state;

  const getLinks = () => {
    setLoader(true);
    axiosInstance
      .get(`admin/get/all/description/data`)
      .then(function (response) {
        console.log(response, "Getting Companies");
        if (response?.data.status === true) {
          setData(response?.data?.data);
          console.log(response);
          setLoader(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };
  const getTypes = () => {
    setLoader(true);
    axiosInstance
      .get(`admin/get/all/description/types`)
      .then(function (response) {
        console.log(response, "Getting Types");
        if (response?.data.status === true) {
          const options = response?.data?.data.map((opt) => ({
            label: opt.name,
            value: opt.id,
          }));
          setTypes(options);
          console.log(response);
          setLoader(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };

  const addLink = () => {
    setLoader(true);
    var formdata = new FormData();
    for (const key in fieldvalue) {
      if (Object.hasOwnProperty.call(fieldvalue, key)) {
        if (key === "type") {
          formdata.append("type_id", fieldvalue[key]["value"]);
        } else formdata.append(key, fieldvalue[key]);
      }
    }
    axiosInstance
      .post(`admin/add/description/data`, formdata)
      .then((response) => {
        if (response.data.status) {
          getLinks();
          onHide();
          setFieldValue({});
          toast.success(response.data.message);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValue({ ...fieldvalue, [name]: value });
  };

  const handleCreate = (inputValue) => {
    setIsLoading(true);
    var formdata = new FormData();

    formdata.append("type", inputValue);

    axiosInstance
      .post(`admin/add/description/types`, formdata)
      .then((response) => {
        if (response.data.status) {
          getTypes();
          toast.success(response.data.message);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const handleDeleteOption = (optionToDelete) => {
    setIsLoading(true);

    axiosInstance
      .delete(`admin/del/description/types/${optionToDelete.value}`)
      .then((response) => {
        if (response.data.status) {
          getTypes();
          toast.success(response.data.message);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getLinks();
    getTypes();
  }, []);
  return (
    <>
      {loader && <div className="loader" />}
      <div className="card">
        <div>
          <div className="card-header">
            <h4 className="card-title float-left">Link</h4>
            <button className="btn btn-primary float-end" onClick={onShow}>
              Add Link
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table
              {...getTableProps()}
              id="table-to-export" // Add the id attribute
              className="table display"
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {/* {column.canFilter ? column.render("Filter") : null} */}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {" "}
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Add Modal */}
      <Modal show={show} onHide={onHide} size="md">
        <Modal.Header closeButton>Add Links</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h5 className="text-capitalize">Name</h5>

                <input
                  type="text"
                  name="name"
                  required
                  className="form-control p-2"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-6">
                <h5 className="text-capitalize">Type</h5>

                <CreatableSelect
                  isClearable
                  components={{ Option: CustomOption }}
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  onCreateOption={handleCreate}
                  onChange={(value) =>
                    setFieldValue({ ...fieldvalue, type: value })
                  }
                  onDeleteOption={handleDeleteOption}
                  options={types}
                  value={fieldvalue?.type}
                />
              </div>
              <div className="col-md-12 mt-3">
                <h5 className="text-capitalize">Link</h5>

                <input
                  type="url"
                  required
                  name="link"
                  className="form-control p-2"
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onHide}>
            Close
          </Button>
          <Button variant="success" onClick={addLink}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Add Modal Close */}
    </>
  );
};
export default Links;
